import React from 'react';
import { OnboardingStepGate } from '../../components/OnboardingStepGate';
import { ROUTES_PATH } from '../../constants/Routes';
import { useOnboardingWelcome } from './useOnboardingWelcome';

interface OnboardingWelcomeGateProps {
  children: React.ReactNode;
  isExempt?: boolean;
}

export function OnboardingWelcomeGate({
  children,
  isExempt,
}: OnboardingWelcomeGateProps) {
  const { status, isPollingCredits } = useOnboardingWelcome();

  return (
    <OnboardingStepGate
      status={status}
      stepPath={ROUTES_PATH.ONBOARDING.WELCOME}
      isPollingCredits={isPollingCredits}
      isExempt={isExempt}
    >
      {children}
    </OnboardingStepGate>
  );
}
